import React, { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { useSelector } from "react-redux";
import { SOCKET_URL } from "../utils/constants";
import { toast } from "react-toastify";

const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [userdata, setUserdata] = useState({});
  const [userId,setUserId] = useState("");
  const [notifications, setNotifications] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("notifications")) || [];
    } catch {
      return [];
    }
  });
  const [bellNotifyCount, setBellNotifyCount] = useState(() => {
    return Number(localStorage.getItem("bellNotifyCount")) || 0;
  });
  const [userCurrentRoom, setUserCurrentRoom] = useState(() => {
    return localStorage.getItem("userCurrentRoom") || "";
  });

  const { token, user } = useSelector((state) => state.auth);

  // Safe user data processing
  useEffect(() => {
    if (!user) return;

    if (typeof user === "string") {
      try {
        const parsedUser = JSON.parse(user);
        if (parsedUser && typeof parsedUser === "object") {
          setUserdata(parsedUser);
        } else {
          console.warn("Parsed user is not an object");
        }
      } catch (error) {
        console.error("Failed to parse user JSON:", error);
      }
    } else if (typeof user === "object" && user !== null) {
      setUserdata(user);
    } else {
      console.warn("Invalid user format:", user);
    }
  }, [user]);

  useEffect(()=>{
    if(userdata){
      setUserId(userdata.user?userdata.user._id:userdata._id);
    }
  },[userdata])


  const username = userdata?.name || "";

  const reconnectSocket = (token, userId, username) => {
    if (socket) {
      socket.disconnect();
    }

    const newSocket = io(SOCKET_URL, {
      query: { token, username },
      autoConnect: false,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    });

    newSocket.connect();
    setSocket(newSocket);

    let pingInterval = null;

    newSocket.on("connect", () => {
      sessionStorage.setItem("socketId", newSocket.id);
      newSocket.emit("tryingToReconnect", userId);

      pingInterval = setInterval(() => {
        newSocket.emit("ping");
      }, 10000);
    });

    newSocket.on("disconnect", (reason) => {
      console.warn("⚠️ Socket disconnected:", reason);
      clearInterval(pingInterval);
    });
  };

  useEffect(() => {
    if (!token || !userId) return;

    reconnectSocket(token?token.token?token.token:token:null, userId, username);

    return () => {
      if (socket) socket.disconnect();
    };
  }, [token, userId, username]);

  useEffect(() => {
    if (!socket) return;

    socket.on("notification", (data) => {
      if (Array.isArray(data)) {
        // setNotifications(data);
      } else {
        // toast.success(`${data.title}: ${data.message}`);
        // setNotifications((prev) => [data, ...prev]);
      }
    });

    socket.on("bell-notify", (count) => {
      setBellNotifyCount(count);
    });

    socket.on("nextAuctionTicket", (data) => {
      if (data.room === userCurrentRoom) {
        // toast.success(`${data.message}`);
      }
    });

    return () => {
      socket.off("notification");
      socket.off("bell-notify");
      socket.off("nextAuctionTicket");
    };
  }, [socket, userCurrentRoom]);

  useEffect(() => {
    localStorage.setItem("notifications", JSON.stringify(notifications));
  }, [notifications]);

  useEffect(() => {
    localStorage.setItem("bellNotifyCount", bellNotifyCount);
  }, [bellNotifyCount]);

  useEffect(() => {
    localStorage.setItem("userCurrentRoom", userCurrentRoom);
  }, [userCurrentRoom]);

  return (
    <SocketContext.Provider
      value={{
        socket,
        notifications,
        setNotifications,
        bellNotifyCount,
        setBellNotifyCount,
        userCurrentRoom,
        setUserCurrentRoom,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);